import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { useQueryClient } from 'react-query';

const endpoint = 'ums/v1/supplier-intelligence/sheets/refresh';

type TData = { success: boolean; message: string };
type TError = AxiosError;
type TVariables = void;
type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useRefreshSiSheetsApi(options?: Options): ReturnType {
  const toast = useCustomToast();
  const queryClient = useQueryClient();

  const mutationFn = async () => {
    try {
      const { data } = await http.post(endpoint);
      return data;
    } catch (error: any) {
      if (!error.response?.status || !error.response?.data?.message) throw error;
      toast({ description: error.response.data.message, status: 'error' });
      throw error;
    }
  };

  return useMutationWrapper(mutationFn, {
    ...options,
    mutationKey: [endpoint],
    onSuccess: () => {
      queryClient.invalidateQueries('ums/v1/supplier-intelligence');
      toast({ description: 'Data refreshed successfully', status: 'success' });
    },
  });
}
